import classNames from 'classnames';
import React, { useMemo } from 'react';
import { Card } from 'react-bootstrap';
import Header from './header/Header';
import { Props, Option } from './answer.type';
const AnswerOption = ({ active, label, value, onClick }: Option) => {
  return (
    <Card className="cursor-pointer mb-4" onClick={() => onClick(value)}>
      <Card.Body>
        <div className="d-flex align-items-center justify-content-between">
          <div>{label}</div>
          <h4
            className={classNames('m-0 fs-2 text-uppercase', {
              'text-primary': active,
              'text-secondary-light': !active
            })}
          >
            {value}
          </h4>
        </div>
      </Card.Body>
    </Card>
  );
};

function Answer({
  data,
  onSelect,
  selectedAnswer,
  onNext,
  answerSubmissionLoader,
  currentStep,
  onSubmit,
  submitLoader,
  onTimeEnd
}: Props) {
  const { question, total, endTime } = data;
  const examEndTime = useMemo(() => {
    let time = endTime;
    if (endTime) {
      const endDate = new Date(endTime);
      endDate.setSeconds(endDate.getSeconds() - 5);
      time = endDate.toISOString();
    }
    return time;
  }, [endTime]);
  return (
    <div>
      <Header
        total={total}
        type={question?.type}
        onNext={() => onNext(question?._id)}
        disabled={selectedAnswer.length === 0}
        nextButtonLoader={answerSubmissionLoader}
        currentStep={currentStep}
        onSubmit={() => onSubmit(question?._id)}
        submitButtonLoader={submitLoader}
        endTime={examEndTime}
        onTimeEnd={onTimeEnd}
      />
      {question && (
        <section className="user-select-none">
          {question.options.map(({ option, value }, idx) => {
            return (
              <AnswerOption
                key={idx}
                active={selectedAnswer.includes(value)}
                label={option}
                value={value}
                onClick={onSelect}
              />
            );
          })}
        </section>
      )}
    </div>
  );
}

export default Answer;
